var map = {
	"./en/locale.json": [
		5,
		[
			5
		]
	],
	"./en/resource.json": [
		771,
		[
			771
		]
	],
	"./nl/locale.json": [
		166,
		[
			166
		]
	],
	"./nl/resource.json": [
		988,
		[
			988
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 968;
module.exports = webpackAsyncContext;